import { useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useDeepCompareEffect } from 'react-use';
import { isUndefined } from 'lodash';

import { Anchor, AnchorAlignment, Message, MessageType } from '@dreryk/react-components';

import { AppointmentFormController } from '../AppointmentForm.types';
import { ReceptionServiceTableBean } from '../../../../../receptionService/extensions/calendar/appointment/interactiveTable/ReceptionServiceInteractiveTable.types';

import { useVideoConsultationWarningMessageOptions } from './VideoConsultationWarning.hooks';
import { getWarningMessage } from './VideoConsultationWarning.utils';

type VideoConsultationWarningProps = Pick<AppointmentFormController, 'watch' | 'control'>;

export const VideoConsultationWarning = (props: VideoConsultationWarningProps): JSX.Element | null => {
   const [warningMessage, setWarningMessage] = useState<string | undefined>(undefined);
   const statusOptions = useVideoConsultationWarningMessageOptions();
   const formValues = props.watch();
   const receptionServiceValue = useWatch<ReceptionServiceTableBean[]>({
      name: 'receptionService.value',
      control: props.control,
      defaultValue: formValues.receptionService?.value ?? [],
   });

   useDeepCompareEffect(() => {
      setWarningMessage(getWarningMessage(receptionServiceValue, formValues.videoConsultation));
   }, [receptionServiceValue, formValues.videoConsultation]);

   if (isUndefined(warningMessage)) {
      return null;
   }

   return (
      <Anchor shouldPerformScroll verticalAlignment={AnchorAlignment.END} testId={'videoConsultationWarning'}>
         <Message
            testId={'videoConsultationWarning'}
            type={MessageType.WARNING}
            label={warningMessage}
            displayIndicator
            options={statusOptions}
         />
      </Anchor>
   );
};
